<template>
  <div class="container-fluid px-0">
    <div class="row">
      <div class="col-xl-12">
        <el-carousel class="bannner" :autoplay="true" :height="bannerImageHeight + 'px'">
          <el-carousel-item v-for="(item,index) in ImgUrl" :key="index">
            <a :href="item.HrefUrl" class="d-block" id="banner-img">
              <el-image style="width: 100%;" :src="ossUrl+item.ImgUrl" fit="cover" @load="handleBannerImageHeight" @error="handleBannerImageHeight" @click="cancelStyle">
                <template slot="error">
                  <img class="el-image__inner" style="object-fit: cover;" :src="url + item.ImgUrl" alt="">
                </template>
              </el-image>
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-10">
        <div class="section about">
          <div class="d-flex justify-content-center align-items-center mb-5">
            <div class="section__title">
              <span class="section__title__line"></span>
              <span class="section__title__circular"></span>
              <h3 class="section__title__text">{{ indexForm.about.sectionTitle }}</h3>
              <span class="section__title__circular"></span>
              <span class="section__title__line"></span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-8 col-md-7">
              <div class="section__content">
                <div class="about__scroll" :style="{height: aboutImgHeight + 'px'}">
                  <div class="about__title">
                  {{ indexForm.about.title }}
                </div>
                <div class="about__sub_title mb-3">
                  {{ indexForm.about.subTitle }}
                </div>
                <div class="about__content">
                  <p v-for="(item, index) in formatContent(indexForm.about.content)" :key="index">
                    {{ item }}
                  </p>
                </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-5">
              <div class="section__content" id="about-img">
                <el-image style="width: 100%;" :src="ossUrl+indexForm.about.image" fit="cover" @load="handleAboutImgHeight" @error="handleAboutImgHeight" @click="cancelStyle">
                  <template slot="error">
                    <img class="el-image__inner" style="object-fit: cover;" :src="url + indexForm.about.image" alt="">
                  </template>
                </el-image>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="section__content">
                <div class="about__list">
                  <div class="row">
                    <div v-for="(item, index) in indexForm.about.list" :key="index" :class="index != 3 ? 'col-lg-3 mb-4 mb-lg-0' : 'col-lg-3'">
                      <div class="about__list__item">
                        <h3 class="about__list__item__num">
                          {{ item.num }}
                          <span class="about__list__item__unit">{{ item.unit }}</span>
                        </h3>
                        <p class="about__list__item__desc">{{ item.desc }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="advantage" class="row justify-content-center">
      <div class="col-xl-10">
        <div class="section advantage">
          <div class="d-flex justify-content-center align-items-center mb-5">
            <div class="section__title">
              <span class="section__title__line"></span>
              <span class="section__title__circular"></span>
              <h3 class="section__title__text">{{ advantage.Name }}</h3>
              <span class="section__title__circular"></span>
              <span class="section__title__line"></span>
            </div>
          </div>
          <template v-if="advantage.children">
            <div v-for="(item, index) in advantage.children" :key="index" class="row">
              <template v-if="index %2 != 0">
                <div class="col-lg-5 mb-5">
                  <div class="section__content">
                    <h3 class="advantage__title">
                      {{ item.Name }}
                    </h3>
                    <div v-html="item.Content" class="advantage__content"></div>
                  </div>
                </div>
                <div class="col-lg-7 mb-5">
                  <div v-if="item.Photos && item.Photos.length == 1 " class="section__content">
                    <el-image style="width: 100%;border-radius: 5px;padding: 0 15px;" :src="ossUrl+item.Photos[0].ImgUrl" fit="cover" @click="cancelStyle">
                      <template slot="error">
                        <img class="el-image__inner" style="object-fit: cover;" :src="url + item.Photos[0].ImgUrl" alt="">
                      </template>
                    </el-image>
                  </div>
                  <div v-if="item.Photos && item.Photos.length > 1 " class="section__content">
                    <el-carousel class="bannner" :autoplay="true" :height="advantageImageHeight + 'px'">
                      <el-carousel-item v-for="(ite,ind) in item.Photos" :key="ind">
                        <a :href="item.HrefUrl" class="d-block" id="advantage-img">
                          <el-image style="width: 100%;" :src="ossUrl+ite.ImgUrl" fit="cover" @load="handleAdvantageImageHeight" @error="handleAdvantageImageHeight" @click="cancelStyle">
                            <template slot="error">
                              <img class="el-image__inner" style="object-fit: cover;" :src="url + item.ImgUrl" alt="">
                            </template>
                          </el-image>
                        </a>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <div v-else class="section__content">

                  </div>
                </div>
              </template>
              <template v-else>
                <div class="col-lg-7 mb-5">
                  <div v-if="item.Photos && item.Photos.length == 1 " class="section__content">
                    <el-image style="width: 100%;border-radius: 5px;padding: 0 15px;" :src="ossUrl+item.Photos[0].ImgUrl" fit="cover" @click="cancelStyle">
                      <template slot="error">
                        <img class="el-image__inner" style="object-fit: cover;" :src="url + item.Photos[0].ImgUrl" alt="">
                      </template>
                    </el-image>
                  </div>
                  <div v-if="item.Photos && item.Photos.length > 1 " class="section__content">
                    <el-carousel class="bannner" :autoplay="true" :height="advantageImageHeight + 'px'">
                      <el-carousel-item v-for="(ite,ind) in item.Photos" :key="ind">
                        <a :href="item.HrefUrl" class="d-block" id="advantage-img">
                          <el-image style="width: 100%;" :src="ossUrl+ite.ImgUrl" fit="cover" @load="handleAdvantageImageHeight" @error="handleAdvantageImageHeight" @click="cancelStyle">
                            <template slot="error">
                              <img class="el-image__inner" style="object-fit: cover;" :src="url + item.ImgUrl" alt="">
                            </template>
                          </el-image>
                        </a>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <div v-else class="section__content">

                  </div>
                </div>
                <div class="col-lg-5 mb-5">
                  <div class="section__content">
                    <h3 class="advantage__title">
                      {{ item.Name }}
                    </h3>
                    <div v-html="item.Content" class="advantage__content"></div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="honor" class="row justify-content-center">
      <div class="col-xl-10">
        <div class="section honor">
          <div class="d-flex justify-content-center align-items-center mb-5">
            <div class="section__title">
              <span class="section__title__line"></span>
              <span class="section__title__circular"></span>
              <h3 class="section__title__text">{{ honor.Name }}</h3>
              <span class="section__title__circular"></span>
              <span class="section__title__line"></span>
            </div>
          </div>
          <template v-if="honor.children">
            <div v-for="(item, index) in honor.children" :key="index" class="row">
              <div class="col-lg-12 mb-4">
                  <div class="section__content">
                    <h3 :class="index %2 == 0 ? 'honor__title d-flex flex-column align-items-start' : 'honor__title d-flex flex-column align-items-end'">
                      {{ item.Name }}
                      <span class="honor__line"></span>
                    </h3>
                  </div>
                </div>
                <template v-if="item.Photos">
                  <div v-for="(ite, ind) in item.Photos" :key="ind" :class="item.Photos.length <= 2 ? 'col-lg-6 mb-4' : 'col-lg-4 mb-4'">
                    <div class="section__content">
                      <el-image style="width: 100%;border-radius: 5px;padding: 0 15px;" :src="ossUrl+ite.ImgUrl" fit="cover" @click="cancelStyle">
                        <template slot="error">
                          <img class="el-image__inner" style="object-fit: cover;" :src="url + ite.ImgUrl" alt="">
                        </template>
                      </el-image>
                    </div>
                  </div>
                </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="news" class="row justify-content-center">
      <div class="col-xl-10">
        <div class="section news">
          <div class="d-flex justify-content-center align-items-center mb-5">
            <div class="section__title">
              <span class="section__title__line"></span>
              <span class="section__title__circular"></span>
              <h3 class="section__title__text">{{ newsClass.Name }}</h3>
              <span class="section__title__circular"></span>
              <span class="section__title__line"></span>
            </div>
          </div>
          <div class="row mx-0">
            <div v-for="(item, index) in news" :key="index" class="col-lg-4 mb-4 px-0">
              <a class="news__item" :href="'news/' + item.ID">
                <div class="news__item__image">
                  <el-image style="width: 100%;border-radius: 10px;height: 210px;" :src="ossUrl+item.ImgUrl" fit="cover" @click="cancelStyle">
                    <template slot="error">
                      <img class="el-image__inner" style="object-fit: cover;" :src="url + item.ImgUrl" alt="">
                    </template>
                  </el-image>
                </div>
                <h3 class="news__item__title">
                  {{ item.Name }}
                </h3>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="textbook" class="row justify-content-center">
      <div class="col-xl-10">
        <div class="section news">
          <div class="d-flex justify-content-center align-items-center mb-5">
            <div class="section__title">
              <span class="section__title__line"></span>
              <span class="section__title__circular"></span>
              <h3 class="section__title__text">{{ textbook.Name }}</h3>
              <span class="section__title__circular"></span>
              <span class="section__title__line"></span>
            </div>
          </div>
          <div class="row mx-0">
            <template v-if="textbook.children">
              <div v-for="(item, index) in textbook.children[0].Photos" :key="index" class="col-lg-4 mb-4 px-0">
                <a class="news__item" href="javascript:void(0);">
                  <div class="news__item__image">
                    <el-image style="width: 100%;border-radius: 10px;" :src="ossUrl+item.ImgUrl" fit="cover" @click="cancelStyle">
                      <template slot="error">
                        <img class="el-image__inner" style="object-fit: cover;" :src="url + item.ImgUrl" alt="">
                      </template>
                    </el-image>
                  </div>
                  <h3 class="news__item__title">
                    {{ item.Name }}
                  </h3>
                </a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="IndexCourseList" class="row justify-content-center">
      <div class="col-xl-10">
        <div class="section news">
          <div class="d-flex justify-content-center align-items-center mb-5">
            <div class="section__title">
              <span class="section__title__line"></span>
              <span class="section__title__circular"></span>
              <h3 class="section__title__text"> {{CenterIfon.LeftText}}</h3>
              <span class="section__title__circular"></span>
              <span class="section__title__line"></span>
            </div>
          </div>
          <div class="row mx-0">
            <template v-if="IndexCourseList">
              <div v-for="(item, index) in IndexCourseList" :key="index" class="col-lg-3 mb-4 px-0">
                <a :href="item.HrefUrl">
                  <div class="news__item">
                    <div class="news__item__image">
                      <el-image style="width: 100%;border-radius: 10px;" :src="ossUrl+item.ImgUrl" fit="cover" @click="cancelStyle">
                        <template slot="error">
                          <img class="el-image__inner" style="object-fit: cover;" :src="url + item.ImgUrl" alt="">
                        </template>
                      </el-image>
                    </div>
                    <h3 class="news__item__title">
                      {{ item.Name }}
                    </h3>
                  </div>
                </a>
              </div>
            </template>
            <div class="col-lg-12 mt-2 mb-5" style="text-align: center;">
              <a :href="CenterIfon.RightUrl" class="more__btn">
                {{CenterIfon.RightText}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      url: 'https://jsg1.oss-cn-beijing.aliyuncs.com/',
      windowWidth: window.innerWidth,
      aboutImgHeight: 0,
      bannerImageHeight: 0,
      advantageImageHeight: 0,
      advantage: {},
      honor: {},
      textbook: {},
      newsClass: {},
      news: {},
      indexForm: {
        about: {
          sectionTitle: '',
          title: '',
          subTitle: '',
          content: '',
          image: '',
          list: [
            {
              num: '',
              unit: '',
              desc: '',
            },
            {
              num: '',
              unit: '',
              desc: '',
            },
            {
              num: '',
              unit: '',
              desc: '',
            },
            {
              num: '',
              unit: '',
              desc: '',
            }
          ]
        }
      },
      ImgUrl: [],
      IndexCourseList: [],
      CenterIfon: {
        LeftText: '',
        RightText: '',
        RightUrl: '',
      },
    };
  },

  watch: {
    windowWidth(val) {
      this.handleAboutImgHeight()
      this.handleBannerImageHeight()
      this.handleAdvantageImageHeight()
    },
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  created() {
    // 关于我们
    this.sApi('getIndex', {}).then(res => {
      this.indexForm = JSON.parse(res.Data.More)
    })
    // 优势
    this.sApi('getPhotos', {ID:1}).then(res => {
      this.advantage = res.Data
    })
    // 荣誉
    this.sApi('getPhotos', {ID:5}).then(res => {
      this.honor = res.Data
    })
    // 教材
    this.sApi('getPhotos', {ID:9}).then(res => {
      this.textbook = res.Data
    })
    // 新闻
    this.sApi('getNewsIndex', {ID:1}).then(res => {
      this.news = res.Data
    })
    // 新闻分类
    this.sApi('getNewsClassInfo', {ID:1}).then(res => {
      this.newsClass = res.Data
    })
    // 横幅，首页课程
    this.sApi('getBannr', {}).then(res => {
      this.ImgUrl = res.BannrList;
      this.IndexCourseList = res.IndexCourseList;
      this.CenterIfon = res.CenterIfon;
    })
  },

  methods: {
    formatContent(content) {
      if (content.indexOf('|') > 0){
        return content.split('|');
      }
      return [content];
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    handleAboutImgHeight() {
      this.aboutImgHeight = document.getElementById('about-img').offsetHeight
    },
    handleBannerImageHeight() {
      this.bannerImageHeight = document.getElementById('banner-img').offsetHeight
    },
    handleAdvantageImageHeight() {
      this.advantageImageHeight = document.getElementById('advantage-img').offsetHeight
    },
    cancelStyle(){
      document.body.style='overflow:auto';
    },
  },
};
</script>

<style lang="scss" >
  body{
    background-color: #ffffff;
  }
  .section {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    margin-top: 3rem;
    &__title {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 400px;
      &__line{
        display: block;
        height: 2px;
        background: #000000;
        flex: 1;
      }
      &__circular{
        display: block;
        height: 8px;
        background: #000000;
        width: 8px;
        border-radius: 4px;
      }
      &__text{
        color: #000000;
        font-weight: bold;
        font-size: 38px;
        padding: 0 24px;
      }
    }
    &__content{
      position: relative;
      box-sizing: border-box;
      min-height:50px;
      margin: 0 -15px;
      padding: 0 15px;
    }
  }

  .about{
    &__scroll{
      overflow-y: auto;
      &::-webkit-scrollbar{
        width: 4px;
        box-sizing: border-box;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background-color: rgba(242,242,242,1);
      }
      &::-webkit-scrollbar-track{
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0);
        border-radius: 2px;
        background: #ffffff;
      }
    }
    &__title{
      font-size: 25px;
      font-weight: bold;
      color: #000000;
      line-height: 1.8;
      padding: 0 15px;
    }
    &__sub_title{
      font-size: 18px;
      font-weight: bold;
      color: #000000;
      line-height: 1.8;
      padding: 0 15px;
    }
    &__content{
      p{
        font-size: 14px;
        color: #000000;
        line-height: 30px;
        margin: 0;
        padding: 0 15px;
      }
    }
    &__list{
      margin: 15px;
      padding: 15px;
      border: 1px solid rgba(242,242,242,1);
      &__item{
        &__num{
          color: rgb(191, 0, 0);
          font-size: 50px;
        }
        &__unit{
          color: #000000;
          font-size: 14px;
          display: inline-block;
        }
        &__desc{
          margin: 0;
          color: #000000;
          padding-top: 8px;
          font-weight: bold;
          font-size: 14px;
        }
      }
    }
  }

  .advantage{
    &__title{
      margin-bottom: 1.5rem;
      font-weight: bold;
      font-size: 25px;
      color: #000000;
      padding: 0 15px;
    }
    &__content{
      margin: 0;
      font-size: 14px;
      line-height: 32px;
      color: #000000;
      text-align: justify;
      padding: 0 15px;
      span{
        color: rgb(191, 0, 0);
        font-weight: bold;
      }
      p{
        margin: 0;
      }
    }
  }

  .honor{
    &__title{
      font-size: 38px;
      line-height: 60px;
      font-weight: bold;
      color: #000000;
      padding: 0 15px;
    }
    &__line{
      background: linear-gradient(90deg,rgba(127,0,0,1),rgba(127,0,0,1));
      width: 140px;
      box-sizing: border-box;
      display: inline-block;
      height: 5px;
      margin: 2rem 0;
    }
  }

  .news{
    &__item{
      display: block;
      color: #000000;
      margin: 0 15px;
      &:hover{
        color: #000000;
        text-decoration: none;
        .el-image{
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
        }
      }
      &__title{
        font-size: 16px;
        line-height: 32px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .more__btn{
    display: inline-block;
    width: 200px;
    font-size: 16px;
    background: #007bff;
    color: #ffffff;
    text-align: center;
    padding: 15px;
    &:hover{
      color: #ffffff;
      text-decoration: none;
    }
  }

  @media (max-width: 768px) {
    .section{
      &__title{
        width: 100%;
        padding: 0 15px;
      }
    }
  }
</style>
